import { create } from "zustand";
import {
  SalesOrder,
  SalesOrdersQuery,
  SalesOrdersState,
} from "../types/sales_order";
import { useFetcher } from "./fetcher";
import { Paging } from "../types/paging";
import { sortQueryFromOrderByRecord } from "../utils/query";

export const useSalesOrdersStore = create<SalesOrdersState>(
  (set, get) =>
    ({
      items: [],
      total: null,
      query: null,
      limit: 20,
      showFilter: (() => { try { const v = localStorage.getItem('showFilter:sales-orders'); return v !== null ? JSON.parse(v) : true; } catch { return true; } })(),
      search: async (query?: SalesOrdersQuery, fetch?: boolean) => {
        set(() => ({ query }));
        if (fetch !== false) {
          await get().fetch(true);
        }
      },
      fetch: async (reset: boolean): Promise<Paging<SalesOrder> | null> => {
        try {
          const { items, limit, query, total } = get();
          if (!reset && total !== null && total <= items.length ) {
            return null;
          }

          const sort = sortQueryFromOrderByRecord(query?.order_by);
          const params: any = query
            ? {
                ...query,
                order_by: undefined,
                sort,
                limit,
                offset: reset ? 0 : items.length,
              }
            : { limit, offset: reset ? 0 : items.length };
          const res = await useFetcher
            .getState()
            .omsDsFetcher.get<Paging<SalesOrder>>("sales-orders", {
              params,
              paramsSerializer: {
                indexes: null,
              },
            });

          set(() => ({
            items: [...(reset ? [] : items), ...(res?.data?.items ?? [])],
            total: res?.data?.total ?? null,
          }));
          return res?.data ?? null;
        } catch (error) {
          throw error;
        }
      },
      get: async (id: string): Promise<SalesOrder | null> => {
        try {
          const res = await useFetcher
            .getState()
            .omsDsFetcher.get<SalesOrder>(`sales-orders/${id}`);
          return res?.data ?? null;
        } catch (error) {
          throw error;
        }
      },
      dblkPromotion: async (id: string): Promise<void> => {
        try {
          await useFetcher
            .getState()
            .omsDsFetcher.post(`sales-orders/${id}/dblk-promotion`);
        } catch (error) {
          throw error;
        }
      },
      mpMission: async (id: string): Promise<void> => {
        try {
          await useFetcher
            .getState()
            .omsDsFetcher.post(`sales-orders/${id}/mp-mission`);
        } catch (error) {
          throw error;
        }
      },
      clear: () => {
        set(() => ({ items: [], total: null, query: null }));
      },
      setShowFilter: async (value: boolean): Promise<void> => {
        set(() => ({
          showFilter: value,
        }));
        try { localStorage.setItem('showFilter:sales-orders', JSON.stringify(value)); } catch {}
      },
    } as SalesOrdersState)
);
